/**
 * MAS stand-in for AutoTemplated's api.js: same function names where possible,
 * so the ported editor stays close to the original. Everything goes through
 * the MAS backend (/api/editor).
 */
import api from "../services/api";

// Fonts are served from frontend/public/editor-fonts (see fonts.js).
export const API_BASE = process.env.PUBLIC_URL || "";

export function toAbsoluteUrl(path) {
  return path || "";
}

/**
 * The editor appends "?canvas=1" to image URLs so the browser re-requests
 * them with CORS (it may have a non-CORS copy cached from an <img>). That
 * would break data:/blob: URLs and URLs that already have a query string.
 */
export function canvasUrl(path) {
  const url = toAbsoluteUrl(path);
  if (!url || /^(data|blob):/i.test(url)) return url;
  return url + (url.includes("?") ? "&" : "?") + "canvas=1";
}

// ---- The document being edited: a template or one History design -----------

const docPath = (mode, id) => `/editor/${mode === "template" ? "templates" : "designs"}/${id}`;

export async function loadDocument(mode, id) {
  try {
    return (await api.get(docPath(mode, id))).data;
  } catch (err) {
    throw new Error(err.response?.data?.detail || "Could not open this design");
  }
}

/** `render`: also replace the design's PNG (Save), not just the document. */
export async function saveDocument(mode, id, payload, { render = false } = {}) {
  await api.put(docPath(mode, id), payload, { params: { render } });
}

export async function renderDocument(payload, format) {
  const { data } = await api.post("/editor/render", payload, { params: { format }, responseType: "blob" });
  return data;
}

// ---- Images ----------------------------------------------------------------

function upload(file, listed, onProgress) {
  const form = new FormData();
  form.append("file", file);
  form.append("listed", listed);
  return api
    .post("/editor/assets", form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => e.total && onProgress?.(e.loaded / e.total),
    })
    .then((r) => r.data);
}

export const uploadAsset = (file, onProgress) => upload(file, false, onProgress);
export const uploadBankImage = (file, onProgress) => upload(file, true, onProgress);
export const listBankImages = () => api.get("/editor/assets").then((r) => r.data);

// ---- Brand kit (colour swatches in the colour picker), per browser ----------

const BRAND_KEY = "masEditor:brandKit";
const MAS_BRAND = { name: "MAS", fonts: [], colors: ["#5842f4", "#d32f2f", "#545454", "#000000", "#ffffff", "#eff9ff"] };

export async function getBrandKit() {
  try {
    return JSON.parse(localStorage.getItem(BRAND_KEY)) || MAS_BRAND;
  } catch {
    return MAS_BRAND;
  }
}

export async function saveBrandKit(kit) {
  try {
    localStorage.setItem(BRAND_KEY, JSON.stringify(kit));
  } catch {
    /* ignore */
  }
  return kit;
}
